import { useCallback, useState } from 'react'

export function useFileUpload({ onStarting } = {}) {
	const [, setFileName] = useState(undefined)
	// const [args, setArgs] = useState(undefined)
	const uploadFile = useCallback((event, ...args) => {
		if (!event?.target?.files[0]) {
			return
		}
		setFileName(event?.target.name)
    // setArgs({...args})
		onStarting(event?.target?.files[0], args)
	}, [onStarting])

	return [uploadFile];
};
